<app-base-error errorCode="403">
    <span title>Protected resource</span>
    <span message>
        You cannot access the page you are requesting because you do not have
        the necessary authorizations.
    </span>
  </app-base-error>
  